










import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'GlobalOverlay',
})
export default class extends Vue {
  get overlay() {
    return AppModule.overlay;
  }
}
